import _ from 'lodash'
import httpClient from '../services/httpClient'

class Base {
  constructor(raw) {
    this._raw = raw || {}
    this.data = this._raw.data
  }
  getLink(key) {
    if (this._raw.links) {
      return this._raw.links[key]
    }
    return null
  }
  getMeta(key) {
    if (this._raw.meta) {
      if (this._raw.meta[key] !== undefined) {
        return this._raw.meta[key]
      }
      // Normalise API meta key differences
      if (key === 'recordsTotal') {
        return this._raw.meta['total']
      }
      if (key === 'pageNumber') {
        return this._raw.meta['current_page']
      }
      if (key === 'perPage') {
        return this._raw.meta['per_page']
      }
    }
    return null
  }
  toJSON() {
    throw new Error('not implemented error')
  }
  findIncluded({ type, id }) {
    return _.find(
      this._raw.included,
      item => item.type === type && item.id === id
    )
  }
}

export class Entity extends Base {
  constructor(...args) {
    super(...args)
    if (!this.data) {
      this.data = this._raw
    }
    this.id = this.data.id
    this.type = this.data.type
    this.source = this.data.source
  }
  get(key) {
    return this.data.attributes[key]
  }
  set(key, val) {
    this.data.attributes[key] = val
  }
  getRelated(key) {
    if (
      !this.data.relationships ||
      !this.data.relationships[key] ||
      !this.data.relationships[key].data
    ) {
      return null
    }
    let related = this.data.relationships[key].data
    if (_.isArray(related)) {
      return new Collection({
        data: related.map(item => this.findIncluded(item) || item)
      })
    }
    return new Entity(this.findIncluded(related) || related)
  }
  removeRelated(key, id) {
    if (
      !this.data.relationships ||
      !this.data.relationships[key] ||
      !this.data.relationships[key].data
    ) {
      return
    }
    let related = this.data.relationships[key].data
    if (_.isArray(related)) {
      this.data.relationships[key].data = related.filter(item => item.id !== id)
    } else {
      delete this.data.relationships[key]
    }
  }
  toJSON() {
    return {
      id: this.data.id,
      type: this.data.type,
      attributes: _.cloneDeep(this.data.attributes)
    }
  }
  clone() {
    return new Entity(this._raw)
  }
}

export class Collection extends Base {
  constructor(...args) {
    super(...args)
    if (!this.data) {
      this.data = []
    }
    this.data = this.data.map(item => {
      item.included = this._raw.included
      return new Entity(item)
    })
  }
  size() {
    return this.data.length
  }
  get(id) {
    return _.find(this.data, item => item.id === id)
  }
  set(item) {
    const i = _.findIndex(this.data, _item => _item.id === item.id)
    if (i < 0) {
      this.data.push(item)
      if (this._raw.meta) {
        this._raw.meta.recordsTotal++
      }
    } else {
      this.data[i] = item
    }
  }
  //at (index) {
  //  return this.data[index]
  //}
  getPageNumber() {
    const pageNumber = this.getMeta('pageNumber')
    if (pageNumber) {
      return parseInt(pageNumber)
    }
    return -1
  }
  toJSON() {
    return this.data.map(entity => entity.toJSON())
  }
}

function createEntity(raw) {
  if (_.isArray(raw.data)) {
    return new Collection(raw)
  }
  return new Entity(raw)
}

function jsonApi(fetchFn) {
  return (url, data) => {
    if (data) {
      if (_.isFunction(data.toJSON)) {
        data = data.toJSON()
      }
      data = { data }
    }
    return fetchFn(url, data).then(createEntity)
  }
}

function jsonApiNew(fetchFn) {
  return (url, data) => {
    if (data) {
      if (_.isFunction(data.toJSON)) {
        data = data.toJSON()
      }
      data
    }
    return fetchFn(url, data).then(createEntity)
  }
}

/**
 * Wraps an Axios call so it returns the raw JSON body (not the Axios envelope).
 * For DELETE requests that carry a body, Axios requires the body in config.data.
 * Errors are normalized to expose `error.status` matching legacy callers.
 */
function axiosMethod(method) {
  return function(url, body) {
    let promise
    if (method === 'get') {
      promise = httpClient.get(url)
    } else if (method === 'delete') {
      promise = httpClient.delete(url, body !== undefined ? { data: body } : undefined)
    } else {
      promise = httpClient[method](url, body)
    }
    return promise
      .then(res => res.data)
      .catch(err => {
        const out = new Error(err.message)
        out.status = err.response ? err.response.status : null
        out.response = err.response
        throw out
      })
  }
}

const request = {}
;['get', 'post', 'put', 'patch', 'delete'].forEach(method => {
  request[method] = jsonApi(axiosMethod(method))
})

// Allow callers to update shared default headers. Auth is not one of them: the
// session rides in an HttpOnly cookie the browser attaches itself, so nothing
// here sets an Authorization header any more.
request.headers = headers => {
  Object.assign(httpClient.defaults.headers.common, headers)
}

const requests = {}
;['get', 'post', 'put', 'patch', 'delete'].forEach(method => {
  requests[method] = jsonApiNew(axiosMethod(method))
})

requests.headers = request.headers

export { requests }
export default request
